<template>
  <div id="app">
    <Header key="header" />
    <transition-group name="fade" v-if="!loading">
      <Acordeon key="preciosA" :listado="listado" :excepciones="excepciones" :legal="legal" :concesionarias="concesionarias" :entorno="entorno" :query="modelo" />
    </transition-group>
    <div class="container" v-else>
      <p class="intro-copy">Cargando...</p>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Acordeon from "./components/Acordeon";
import axios from "axios";

/* eslint-disable */
// const API_URL = "https://precios.vwcontenidos.com.ar/api";
// const NEW_URL = "https://eficiencia-energetica.vwcontenidos.com.ar/api";
const API_INSTITUCIONAL = "https://institucional.vwcontenidos.com.ar/api";
const API_URL = "https://eficiencia-energetica.vwcontenidos.com.ar/api";

export default {
  name: "app",
  components: {
    Header,
    Acordeon
  },
  data() {
    return {
      loading: true,
      listado: [],
      excepciones: [],
      legal: '',
      concesionarias: [],
      modelo: null,
      entorno: 'prod'
    };
  },
  mounted: function() {
    this.modelo = this.getParameterByName('q');
    this.entorno = this.getParameterByName('env') && this.getParameterByName('env') == 'qa' ? 'qa' : 'prod';
    axios.get(API_INSTITUCIONAL + "/services").then(response => {
      this.listado = response.data.listado;
      this.excepciones = response.data.excepciones;
      this.loading = false;
      document.title = "Services | Volkswagen Argentina";
    });
    axios.get(API_INSTITUCIONAL + "/informacion/postventa-contrato-mantenimiento").then(response => {
      this.concesionarias = response.data.concesionarias;
      this.legal = response.data.legales[0].legales;
    });
  }, 
  methods: {
    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  }
};
</script>

<style lang="scss">
@import "./assets/scss/_fonts.scss";

* {
  transition: all 300ms ease-in-out;
}

body {
  // @media(max-width: 1441px) {
  //   font-size: 12px;
  // }
  // @media(max-width: 1023px) {
  //   font-size: 11px;
  // }
  @media(max-width: 767px) {
    font-size: 10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

:root {
  --textShadow: 0 1px 2px rgba(#000, 0.2);
}

$azul: #001e50;

#app {
  font-family: "vw-head", Arial, Helvetica, sans-serif;
  min-height: 1080px;
  position: relative;
  padding: 7em 0;
  font-size: 16px;
  @media(max-width: 1441px) {
    font-size: 12px;
  }
  @media(max-width: 1025px) {
    font-size: 11px;
  }
  @media(max-width: 769px) {
    font-size: 10px;
  }
  @media (min-width: 1630px) {
    .container {
      width: 100%;
      max-width: 1630px;
    }
  }
  h1, h2, h3, .intro-copy {
    color: $azul;
  }
  .intro-copy {
    margin: 1.25em auto 0.4em;
    font-size: 2em;
    font-weight: 300;
    color: $azul;
    letter-spacing: -0.015em;
    @media(max-width: 767px) {
      font-size: 1.8em;
    }
  }
  h3 {
    font-size: 3em;
    font-weight: 300;
    line-height: 1.1em;
    letter-spacing: -0.017em;
    margin: 0.95em 0;
    color: black;
    strong {
      letter-spacing: -0.005em;
      font-weight: bold;
      font-size: 1.05em;
    }
    &+p {
      font-size: 1.2em;
      padding: 0 4%;
      max-width: 1200px;
      margin: -0.7em auto 1.5em;
      line-height: 1.9em;
      letter-spacing: 0.004em;
      @media(max-width: 767px) {
        font-size: 1.55em;
        font-weight: bold;
        line-height: 1.4em;
        padding: 5px 3%;
      }
    }
    @media(max-width: 767px) {
      font-size: 3.8em;
      padding: 10px 10px 0 0;
    }
  }
  h4 {
    font-weight: 300;
    letter-spacing: -0.02em;
  }
}

button:focus {
  outline: none;
  box-shadow: none;
}

.btn {
  border-radius: 35px;
  margin: 0.3em 1em;
  font-size: 1.1em;
  padding: 0.4em 2.6em 0.6em;
  letter-spacing: -0.04em;
  @media(max-width: 767px) {
    font-size: 1.6em;
  }
  &:focus {
    outline: none;
    box-shadow: none;
  }
  &.blanco {
    color: #001e50;
    background: #fff;
    border: 1px solid #001e50;
  }
  &.azul {
    color: #fff;
    background: #001e50;
    border: 1px solid #fff;
    @media (orientation: landscape) {
      margin-left: 0.2em;
      padding: 0.4em 2.9em 0.6em;
    }
  }
}

.no-appearance{
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

@supports(-webkit-appearance: none) or (-moz-appearance: none) {
  input[type='checkbox'],
  input[type='radio'] {
    -webkit-appearance: none;
    -moz-appearance: none;
    height: 21px;
    outline: none;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    cursor: pointer;
    border: 2px solid #001e50;
    background: white;
    transition: background .3s, border-color .3s, box-shadow .2s;
    &:after {
      content: '';
      display: block;
      left: 0;
      top: 0;
      position: absolute;
      transition: transform var(--d-t, .3s) var(--d-t-e, ease), opacity var(--d-o, .2s);
      background: #001e50;
    }
    &:checked {
      --b: var(--active);
      --bc: var(--active);
      --d-o: .3s;
      --d-t: .6s;
      --d-t-e: cubic-bezier(.2, .85, .32, 1.2);
    }
    &:disabled {
      --b: var(--disabled);
      cursor: not-allowed;
      opacity: .9;
      &:checked {
        --b: var(--disabled-inner);
        --bc: var(--border);
      }
      & + label {
        cursor: not-allowed;
      }
    }
    &:hover {
      &:not(:checked) {
        &:not(:disabled) {
          --bc: var(--border-hover);
        }
      }
    }
    &:not(.switch) {
      width: 21px;
      margin-right: 10px;
      &:after {
        opacity: var(--o, 0);
      }
      &:checked {
        --o: 1;
      }
    }
    & + label {
      font-size: 1.2em;
      line-height: 1.4em;
      display: inline-block;
      cursor: pointer;
      margin-left: 4px;
      font-weight: 400;
      @media(max-width: 767px) {
        font-size: 2em;
      }
    }
  }
  .radio {
    display: flex;
    align-items: center;
    margin-bottom: 2.2em;
    @media (max-width: 767px) {
      &.fix {
        display: block;
        input {
          float: left;
          margin-top: 4px;
        }
      }
    }
  }
  input[type='checkbox'] {
    &:not(.switch) {
      border-radius: 0;
      border: 1px solid #001e50;
      width: 15px;
      height: 15px;
      min-width: 15px;
      min-height: 15px;
      margin-top: 5px;
      &:after {
        width: 100%;
        height: 100%;
      }
      &:checked {
        background: #001e50;
      }
    }
    &.switch {
      width: 38px;
      border-radius: 11px;
      &:after {
        left: 2px;
        top: 2px;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        background: var(--ab, var(--border));
        transform: translateX(var(--x, 0));
      }
      &:checked {
        --ab: var(--active-inner);
        --x: 17px;
      }
      &:disabled {
        &:not(:checked) {
          &:after {
            opacity: .6;
          }
        }
      }
    }
  }
  input[type='radio'] {
    outline: none;
    box-shadow: none;
    border-radius: 50%;
    &:after {
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background: var(--active-inner);
      opacity: 0;
      transform: scale(var(--s, .7));
      background: #001e50;
    }
    &:checked {
      --s: .5;
    }
  }
}

.v-select .open-indicator::before {
  border-color: #0099da !important;
}

.v-select .selected-tag {
  @media (max-width: 768px) {
    // font-size: 2.3vmax;
  }
}
.v-select .vs__actions {
  padding: 0;
  right: 0;
  top: 5px;
  position: absolute;
  .clear {
    font-size: 17px;
  }
}
.v-select .open-indicator, .v-select .open-indicator:before {
  display: none;
}
.azul {
  color: #001e50;
}
.table-main {
  border: none;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border-spacing: 10px;
  border-collapse: separate;
  td, th {
    border: none;
    border-bottom: 1px solid #DFE4E8;
    // height: 3.2em;
    // vertical-align:middle;
    vertical-align: top;
    @media(max-width: 1441px) {
      height: 42px;
      max-width: 120px;
    }
    &.fix-col {
      // height: 3.2em;
      @media(max-width: 1441px) {
        height: 42px;
      }
    }
    p {
      font-size: 1.2em;
      margin: 0;
      flex: 1;
      // line-height: 1.3em;
      // overflow: hidden;
      // height: 1.3em;
    }
  }
}

.table-main thead th {
  border: none;
  padding: 15px 0;
  text-align: left;
  border-bottom: 1px solid black;
  // height: 4em;
  &.fix-col {
    border: none;
  }
}

.alinear {
  display: flex;
  align-items: center;
  height: 100%;
}

.table-main tbody td {
  color: black;
  padding: 10px 0;
  .detalle_2 p {
    font-size: 0.9em;
  }
  @media(max-width: 767px) {
    p {
      flex-direction: column-reverse;
      display: flex;
    }
  }
}

.table {
  position: relative;
  margin-top: 1.8em;
}

.table-scroll {
  overflow: auto;
  padding-bottom: 5px;
  @media(max-width: 767px) {
    overflow-x: scroll;
    overflow-y: visible;
    margin-left: 20%;
    width: 80%;
  }
  @media(max-width: 767px) {
    margin-left: 150px;
    width: calc(100% - 150px);
  }
}

.table-main .fix-col {
  left: 0;
  top: auto;
  // width: 20%;
  border: none;
  border-bottom: 1px solid #DFE4E8;  
  @media(max-width: 767px) {
    position: absolute;
    width: 150px;
  }
}

ul {
  list-style: none;
}
</style>